import type { NodeInvokeResult } from '@lighthouse/shared'
import { ActionWorker, logMaker, LogSender } from '@lighthouse/shared'

import * as srv from '@/services'

import { actionHandlers, nodeHandlers } from './actionHandlers'
import type { ExecuteActionParams } from './type'

const logSender = new LogSender()

const actionWorker = new ActionWorker<
    ExecuteActionParams,
    typeof nodeHandlers,
    typeof actionHandlers,
    keyof typeof nodeHandlers,
    keyof typeof actionHandlers
>(nodeHandlers, actionHandlers)

actionWorker.use('initialize', async data => {
    const initializeData = data as { flowId: string; invokeId: string }

    logSender.collectLog({
        invokeId: initializeData.invokeId,
        logInvoker: async () => {
            return await srv.createWorkflowLog(initializeData.flowId)
        }
    })

    await logSender.checkIsRunning(initializeData.invokeId)
})

actionWorker.use('afterInvokeNode', async data => {
    const invokedNodeData = data as NodeInvokeResult<ExecuteActionParams>

    const nodeLog = logMaker(invokedNodeData)

    logSender.collectLog({
        invokeId: invokedNodeData.workflowInstanceId,
        logInvoker: async (extraParams: ExecuteActionParams) => {
            return await srv.updateWorkflowLog({ ...nodeLog, ...extraParams })
        }
    })

    await logSender.checkIsRunning(invokedNodeData.workflowInstanceId)
})

actionWorker.use('afterInvoke', () => {
    console.log('afterInvoke')
})

export { actionWorker }
